module.exports = __webpack_public_path__ + "img/forgerock.a43f28ba.png";